<template>
  <div
    class="modal fade show modal-dialog-centered modal-dialog-scrollable"
    style="padding-right: 12px; display: block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="isAdd" class="modal-title">
            Добавление результата анализа для {{ client.fullname }}.
          </h5>
          <h5 v-else class="modal-title">
            Редактирование анализа для {{ client.fullname }}.
          </h5>

          <button type="button" class="close" @click="$emit('cancel')">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>Анализ</label>

              <Select
                :data="list"
                :placeholder="'Название анализа'"
                v-model="test"
                v-if="isAdd"/>
              <div v-else>
                <input
                  class="form-control"
                  type="text"
                  disabled
                  :value="result.testName"/>
              </div>

              <div v-if="testError !== ''" class="invalid-feedback">
                {{ testError }}
              </div>
            </div>
            <div class="form-group">
              <label>Дата</label>
              <input
                type="text"
                :class="'form-control w-25' + (dateError !== '' ? ' is-invalid' : '')"
                v-model="date"/>
              <div v-if="dateError !== ''" class="invalid-feedback">
                {{ dateError }}
              </div>
              <small v-else class="form-text text-muted">
                формат: YYYY-MM-DD
              </small>
            </div>
            <div class="form-group">
              <label>Значение</label>
              <input
                type="text"
                :class="'form-control' + (valueError !== '' ? ' is-invalid' : '')"
                v-model="value"/>
              <div v-if="valueError !== ''" class="invalid-feedback">
                {{ valueError }}
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer justify-content-between">
          <button v-if="!isAdd" type="button" class="btn btn-danger" @click="deleteResult">
            Удалить
          </button>
          <button type="button" class="btn btn-primary" @click="submitResult">
            {{ isAdd ? 'Добавить' : 'Обновить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';
import Select from '../../common/Select';

export default {
  name: 'ClientTestForm',

  props: ['result', 'client', 'tests'],

  components: {Select},

  data() {
    return {
      isAdd: false,
      test: null,
      testError: '',
      value: null,
      valueError: '',
      date: formatDate(new Date(), 'y-m-d'),
      dateError: '',
    };
  },

  created() {
    this.isAdd = typeof this.result === 'undefined';
    this.test = this.isAdd ? null : this.result.testId;
    this.value = this.isAdd ? null : this.result.value;
    this.date = formatDate(this.isAdd ? new Date() : this.result.date, 'y-m-d');
  },

  computed: {
    list() {
      const tests = this.tests.map(i => ({label: i.name, value: i.id}));

      tests.sort((a, b) => {
        return a.label > b.label ? 1 : (a.label < b.label ? -1 : 0);
      });

      return tests;
    },
  },

  watch: {
    test: function () {
      this.testError = '';
    },

    value: function () {
      this.valueError = '';
    },
  },

  methods: {
    submitResult() {
      if (typeof this.test !== 'string' || this.test.trim() === '') {
        this.testError = 'Нужно выбрать анализ';

        return;
      }

      if (typeof this.date !== 'string' || this.date.trim() === '') {
        this.dateError = 'Не указана дата';

        return;
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.date) !== true) {
        this.dateError = 'Дата указана неправильно, нужно указать в формате' +
          ` YYYY-MM-DD, Например ${formatDate(new Date(), 'y-m-d')}`;

        return;
      }

      if (typeof this.value !== 'string' || this.value.trim() === '') {
        this.valueError = 'Не указано значение';

        return;
      }

      const data = {test: this.test, value: this.value, date: this.date};

      if (this.isAdd) {
        this.$emit('create-result', data);
      } else {
        this.$emit('update-result', Object.assign({result: this.result}, data));
      }
    },

    deleteResult() {
      this.$emit('delete-result', this.result.id);
    },
  },
};
</script>
